// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.estimate-detail[data-v-4fa1dce2] {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 10px;
}
.estimate-detail[data-v-4fa1dce2] .tab-btn .table {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.estimate-detail[data-v-4fa1dce2] .tab-btn .table > div {
  flex: 1;
  height: 33% !important;
}
.estimate-detail .top-table[data-v-4fa1dce2] {
  height: 300px;
}
.estimate-detail .bottom-table[data-v-4fa1dce2] {
  height: 300px;
}
.estimate-detail .left-right-box1[data-v-4fa1dce2] {
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/views/InvestmentEstimateSoftware/SchemeInvestmentEstimate/EstimateDetail.vue","webpack://./EstimateDetail.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;ACAF;ADPA;EASI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,WAAA;ACCJ;ADdA;EAeM,OAAA;EACA,sBAAA;ACEN;ADlBA;EAqBI,aAAA;ACAJ;ADrBA;EAyBI,aAAA;ACDJ;ADxBA;EA6BI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,SAAA;ACFJ","sourcesContent":["\n.estimate-detail {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  gap: 10px;\n  ::v-deep .tab-btn .table {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    width: 100%;\n    > div {\n      flex: 1;\n      height: 33% !important;\n    }\n  }\n\n  .top-table {\n    height: 300px;\n  }\n\n  .bottom-table {\n    height: 300px;\n  }\n\n  .left-right-box1 {\n    margin-top: 10px;\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 10px;\n  }\n}\n",".estimate-detail {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  gap: 10px;\n}\n.estimate-detail ::v-deep .tab-btn .table {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n}\n.estimate-detail ::v-deep .tab-btn .table > div {\n  flex: 1;\n  height: 33% !important;\n}\n.estimate-detail .top-table {\n  height: 300px;\n}\n.estimate-detail .bottom-table {\n  height: 300px;\n}\n.estimate-detail .left-right-box1 {\n  margin-top: 10px;\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
